import { combineReducers } from "redux";
import AllReducer from './allReducer'
export default combineReducers({
    AllReducer
})
